{
  "docTasks": {
    "tabLabel": "Tareas",
    "title": "Tareas vinculadas a este documento",
    "count": "{{count}} tarea",
    "count_other": "{{count}} tareas",
    "createPlaceholder": "Nueva tarea para este documento...",
    "empty": "Este documento no tiene tareas vinculadas.",
    "loadError": "No se pudieron cargar las tareas.",
    "created": "Tarea creada para este documento",
    "createError": "No se pudo crear la tarea",
    "untitled": "Tarea sin título",
    "markDone": "Marcar como hecha",
    "markUndone": "Marcar como pendiente",
    "open": "Abrir tarea"
  },
  "editor": {
    "placeholder": "Escribe aquí...",
    "saveButton": "guardar",
    "errors": {
      "tableLoadError": "Error al cargar el componente de tabla",
      "addColumnError": "Error: {{error}}"
    }
  },
  "embed": {
    "database": {
      "copyUid": "Copiar UID",
      "settings": "Configuración",
      "searchPlaceholder": "Buscar...",
      "filters": "Filtros",
      "schema": "Schema:",
      "table": "Tabla:",
      "previewPlaceholder": "Vista previa del contenido de la tabla..."
    },
    "inlineFlow": {
      "loading": "Cargando Inline Flow..."
    },
    "inlineOpsTable": {
      "loading": "Cargando Tabla de Operaciones..."
    }
  },
  "sidebar": {
    "searchPlaceholderActive": "Busca...",
    "searchPlaceholderTrash": "Buscar en Papelera...",
    "createNewDocument": "Crear nuevo documento",
    "options": "Opciones",
    "addPage": "Agregar página",
    "newPageDefaultTitle": "Nueva Página",
    "emptyTrash": "Papelera vacía",
    "trash": "Papelera",
    "backToDocs": "Volver a Docs",
    "moveToTrash": "Mover a Papelera",
    "confirmBulkMoveToTrash": "¿Mover a papelera estos {{count}} documentos y sus subdocumentos?",
    "bulkMoveToTrashSuccess": "Movidos a la papelera correctamente.",
    "menu": {
      "permissionsSharing": "Permisos y Sharing",
      "lock": "Bloquear",
      "unlock": "Desbloquear",
      "moveToTrash": "Mover a Papelera",
      "restore": "Restaurar"
    },
    "confirmMoveToTrash": "¿Mover a papelera?",
    "errors": {
      "lockedCannotDelete": "Este documento está bloqueado y no puede ser eliminado.",
      "deleteError": "Error al eliminar: {{message}}",
      "deleteFailed": "Error al mover a papelera.",
      "unknownError": "Error desconocido"
    }
  },
  "comments": {
    "placeholder": "Escribe un comentario...",
    "submit": "Comentar",
    "cancel": "Cancelar",
    "defaultAuthor": "Usuario",
    "altAuthor": "Autor",
    "altYou": "Tú",
    "altCommenter": "Comentarista"
  },
  "versions": {
    "contentTab": "Contenido",
    "tabLabel": "Versiones",
    "title": "Historial de versiones",
    "empty": "Este documento aún no tiene versiones guardadas.",
    "loading": "Cargando historial...",
    "createButton": "Guardar versión",
    "current": "Versión actual",
    "autosave": "Autoguardado",
    "manual": "Manual",
    "wordCount": "{{count}} palabras",
    "restore": "Restaurar esta versión",
    "restoreConfirm": "¿Restaurar el documento a esta versión? Se guardará una copia del estado actual antes de sobrescribir.",
    "restoreForbidden": "Solo quien creó el documento o un administrador del espacio pueden restaurar versiones.",
    "restored": "Documento restaurado.",
    "diffTruncated": "Diferencias truncadas a las primeras {{count}} palabras.",
    "diffLegendAdded": "Agregado",
    "diffLegendRemoved": "Quitado",
    "loadError": "No se pudo cargar el historial de versiones.",
    "modal": {
      "title": "Guardar una versión",
      "nameLabel": "Nombre de la versión",
      "namePlaceholder": "p. ej. Antes de la revisión de legal",
      "save": "Guardar",
      "cancel": "Cancelar",
      "saving": "Guardando..."
    }
  }
}
